import { gql } from '@apollo/client';

export const PROGRAM_COMPLETIONS_BY_UUID = gql`
  query PROGRAM_COMPLETIONS_BY_UUID($studentUuid: ID!) {
    programCompletions: completionsByStudentUuid(studentUuid: $studentUuid) {
      id
      studentUuid
      academicPartnerName
      academicPartnerUuid
      programName
      programUuid
      programType
      expectedGraduationDate
      actualGraduationDate
      archived
    }
  }
`;

export const CREATE_PROGRAM_COMPLETION = gql`
  mutation CREATE_PROGRAM_COMPLETION($completionData: CreateCompletionInput!) {
    createCompletion(completionData: $completionData) {
      completion {
        id
        studentUuid
        academicPartnerName
        academicPartnerUuid
        programName
        programUuid
        programType
        expectedGraduationDate
        actualGraduationDate
        archived
      }
    }
  }
`;

export const UPDATE_PROGRAM_COMPLETION = gql`
  mutation UPDATE_PROGRAM_COMPLETION($completionId: ID!, $completionData: UpdateCompletionInput!) {
    updateCompletion(completionId: $completionId, completionData: $completionData) {
      completion {
        id
        studentUuid
        academicPartnerName
        academicPartnerUuid
        programName
        programUuid
        programType
        expectedGraduationDate
        actualGraduationDate
        archived
      }
    }
  }
`;

export const DELETE_PROGRAM_COMPLETION = gql`
  mutation DELETE_PROGRAM_COMPLETION($completionId: ID!) {
    deleteCompletion(completionId: $completionId) {
      deleted
    }
  }
`;
